import { render, staticRenderFns } from "./PropertyMaintenanceSystemInfo.vue?vue&type=template&id=b6565f20"
import script from "./PropertyMaintenanceSystemInfo.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports